import { startOfToday } from 'date-fns';
import { InvoiceListItem } from '../../../apis/invoiceApi';

import { blue as blueColor, green as greenColor, orange as orangeColor, purple as purpleColor, red as redColor } from '@mui/material/colors';

export const invoiceStatusColors = {
  overdue: redColor[500],
  paid: greenColor[500],
  partialPaid: orangeColor[700],
  sent: blueColor[500],
  voided: purpleColor[500],
};

export const filterStatuses = [
  { label: 'Overdue', background: invoiceStatusColors.overdue, lightText: true },
  { label: 'Paid', background: invoiceStatusColors.paid, lightText: true },
  { label: 'Partial Paid', background: invoiceStatusColors.partialPaid, lightText: true },
  { label: 'Sent', background: invoiceStatusColors.sent, lightText: true },
  { label: 'Voided', background: invoiceStatusColors.voided, lightText: true },
];

export const getInvoiceStatus = (item: InvoiceListItem) => {
  if (item.status.toLowerCase() === 'sent' || item.status.toLowerCase() === 'partialpaid') {
    if (new Date(item.dueDate) < startOfToday()) {
      return 'Overdue';
    }
  }
  return item.status;
};

export const getInvoiceDisplayStatus = (item: InvoiceListItem) => {
  const status = getInvoiceStatus(item);
  if (item.status === 'PartialPaid' && status !== 'Overdue') {
    return 'Partial Paid';
  }

  return status;
};

export const amountDue = (item: InvoiceListItem) => {
  const status = item.status.toLowerCase();
  return status === 'sent' || status === 'partialpaid' ? item.amountDue : 0;
};
